/**
 * Exit intent feedback poll. The markup is printed in the footer by
 * ProfetExitIntentPoll (profet-includes/templates/exit-intent-poll.php) only
 * on pages that match a rule, so on every other page this does nothing.
 *
 * Ported from the beyclinics theme's bey-exit-intent-poll.js, with the
 * submission handling that bey-form.js does there built in here.
 */
(function () {
	'use strict';

	function init() {
		var dialog = document.getElementById('nk-exit-intent-poll');

		if (!dialog) {
			return;
		}

		// Fixed, not admin-configurable.
		var COOKIE_NAME = 'nk_exit_intent_poll_dismissed';
		var COOKIE_DAYS = 30;
		var HIDDEN_MS = 5000;
		var SCROLL_THRESHOLD = 1000;
		var SCROLL_WINDOW_MS = 600;
		var SUCCESS_CLOSE_MS = 5000;

		// Per form, set via ACF on the nk_feedback_form post.
		var DWELL_MS = (parseInt(dialog.dataset.minDwellSeconds, 10) || 0) * 1000;
		var INACTIVITY_MS = (parseInt(dialog.dataset.inactivitySeconds, 10) || 45) * 1000;
		var MOBILE_CATCH_BACK = dialog.dataset.mobileCatchBack === '1';

		function setCookie(name, value, days) {
			var date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/;SameSite=Strict';
		}

		function getCookie(name) {
			var nameEQ = name + '=';
			var parts = document.cookie.split(';');
			for (var i = 0; i < parts.length; i++) {
				var part = parts[i];
				while (part.charAt(0) === ' ') {
					part = part.substring(1, part.length);
				}
				if (part.indexOf(nameEQ) === 0) {
					return part.substring(nameEQ.length, part.length);
				}
			}
			return null;
		}

		if (getCookie(COOKIE_NAME)) {
			return;
		}

		window.dataLayer = window.dataLayer || [];

		var supportsDialog = typeof dialog.showModal === 'function';
		var pointerFine = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);

		var form = dialog.querySelector('form');
		var body = dialog.querySelector('.nk-exit-intent-poll-body');
		var pageUrlInput = dialog.querySelector('.nk-exit-intent-poll-page-url');
		var formError = dialog.querySelector('.nk-exit-intent-poll-form-error');
		var closeBtn = dialog.querySelector('[data-action="close"]');

		// Remaining-characters hint under each field.
		var charsLeftTemplate = dialog.dataset.charsLeft || '';

		Array.prototype.forEach.call(dialog.querySelectorAll('.nk-exit-intent-poll-field'), function (field) {
			var counter = dialog.querySelector('[data-counter-for="' + field.id + '"]');

			if (!counter || !charsLeftTemplate || !(field.maxLength > 0)) {
				return;
			}

			function updateCounter() {
				var remaining = Math.max(0, field.maxLength - field.value.length);
				counter.textContent = charsLeftTemplate.replace('%d', String(remaining));
			}

			field.addEventListener('input', updateCounter);
			updateCounter();
		});

		var shown = false;
		var lastFocused = null;

		function lockScroll() {
			document.body.classList.add('nk-exit-intent-poll-open');
		}

		function unlockScroll() {
			document.body.classList.remove('nk-exit-intent-poll-open');
		}

		function setInert(on) {
			Array.prototype.forEach.call(document.body.children, function (el) {
				if (el === dialog) {
					return;
				}
				if (on) {
					el.setAttribute('inert', '');
					el.setAttribute('aria-hidden', 'true');
				} else {
					el.removeAttribute('inert');
					el.removeAttribute('aria-hidden');
				}
			});
		}

		function trapFocus(event) {
			if (event.key !== 'Tab') {
				return;
			}

			var focusable = dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

			if (!focusable.length) {
				return;
			}

			var first = focusable[0];
			var last = focusable[focusable.length - 1];

			if (event.shiftKey && document.activeElement === first) {
				event.preventDefault();
				last.focus();
			} else if (!event.shiftKey && document.activeElement === last) {
				event.preventDefault();
				first.focus();
			}
		}

		// Only needed for the fallback (non-native <dialog>) path - a native
		// <dialog> already traps focus and closes on Escape by itself.
		function onFallbackKeydown(event) {
			if (event.key === 'Escape') {
				close();
				return;
			}
			trapFocus(event);
		}

		function cleanupOpenState() {
			setInert(false);
			unlockScroll();
			document.removeEventListener('keydown', onFallbackKeydown);
			if (lastFocused && typeof lastFocused.focus === 'function') {
				lastFocused.focus();
			}
		}

		// The native <dialog> "close" event covers every way it can close
		// (our own close(), Escape, form method="dialog"), so cleanup lives here
		// rather than being duplicated at each call site.
		dialog.addEventListener('close', function () {
			dialog.hidden = true;
			cleanupOpenState();
		});

		// A click that lands on the dialog element itself (not a child) means
		// the user clicked the backdrop/overlay area. But a press that starts
		// inside the panel and is released outside it - selecting the text in
		// the field, or dragging its resize handle - also fires its click on the
		// dialog, and so does one that starts on the backdrop and is released
		// inside the panel. Only a press that both started and ended on the
		// backdrop counts.
		var pressStartedOnBackdrop = false;
		var pressEndedOnBackdrop = false;

		dialog.addEventListener('pointerdown', function (event) {
			pressStartedOnBackdrop = event.target === dialog;
		});

		dialog.addEventListener('pointerup', function (event) {
			pressEndedOnBackdrop = event.target === dialog;
		});

		dialog.addEventListener('click', function (event) {
			if (event.target === dialog && pressStartedOnBackdrop && pressEndedOnBackdrop) {
				close();
			}
			pressStartedOnBackdrop = false;
			pressEndedOnBackdrop = false;
		});

		function open() {
			lastFocused = document.activeElement;
			dialog.hidden = false;

			if (supportsDialog) {
				dialog.showModal();
			} else {
				dialog.setAttribute('open', '');
				dialog.classList.add('nk-exit-intent-poll--open');
				dialog.setAttribute('role', 'dialog');
				dialog.setAttribute('aria-modal', 'true');
				document.addEventListener('keydown', onFallbackKeydown);
			}

			setInert(true);
			lockScroll();

			var field = dialog.querySelector('textarea');
			if (field) {
				field.focus();
			}
		}

		function close() {
			if (supportsDialog) {
				if (dialog.open) {
					dialog.close();
				}
				return;
			}

			dialog.removeAttribute('open');
			dialog.classList.remove('nk-exit-intent-poll--open');
			dialog.hidden = true;
			cleanupOpenState();
		}

		function tryShow(reason) {
			if (shown) {
				return;
			}

			shown = true;

			if (pageUrlInput) {
				pageUrlInput.value = window.location.href;
			}

			dialog.dataset.triggerReason = reason;
			detachTriggers();
			open();

			// Only once the dialog is actually up. Setting it first would lock
			// the visitor out for the full cookie lifetime if open() threw,
			// without them ever having seen the popup.
			setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
		}

		if (closeBtn) {
			closeBtn.addEventListener('click', close);
		}

		/*
		|--------------------------------------------------------------------------
		| Submission
		|--------------------------------------------------------------------------
		*/

		var dataLayerName = form.dataset.dataLayerName;
		var sending = false;
		var submitted = false;

		function onFirstFocus() {
			window.dataLayer.push({ event: dataLayerName + '_start' });
			form.removeEventListener('focus', onFirstFocus, true);
		}

		form.addEventListener('focus', onFirstFocus, true);

		function clearErrors() {
			Array.prototype.forEach.call(form.querySelectorAll('.nk-exit-intent-poll-field--invalid'), function (el) {
				el.classList.remove('nk-exit-intent-poll-field--invalid');
				el.removeAttribute('aria-invalid');
			});

			Array.prototype.forEach.call(form.querySelectorAll('.nk-exit-intent-poll-field-error'), function (el) {
				el.parentNode.removeChild(el);
			});

			formError.hidden = true;
			formError.textContent = '';
		}

		function showFormError(message) {
			formError.textContent = message || dialog.dataset.errorMessage;
			formError.hidden = false;
		}

		// Errors come back keyed by the input's exact name, e.g. answers[feedback].
		function showFieldErrors(params) {
			var firstInvalid = null;
			var unmatched = [];

			Object.keys(params).forEach(function (name) {
				var field = form.querySelector('[name="' + name + '"]');

				if (!field) {
					// Never fail silently: a param this form has no input for
					// would otherwise be rejected with nothing shown at all.
					unmatched.push(params[name]);
					return;
				}

				firstInvalid = firstInvalid || field;
				field.classList.add('nk-exit-intent-poll-field--invalid');
				field.setAttribute('aria-invalid', 'true');

				var errorEl = document.createElement('p');
				errorEl.className = 'nk-exit-intent-poll-field-error';
				errorEl.textContent = params[name];
				field.parentNode.insertBefore(errorEl, field.nextSibling);

				// Clear this field's error as soon as the visitor acts on it.
				field.addEventListener(
					'input',
					function clearFieldError() {
						field.removeEventListener('input', clearFieldError);
						field.classList.remove('nk-exit-intent-poll-field--invalid');
						field.removeAttribute('aria-invalid');
						if (errorEl.parentNode) {
							errorEl.parentNode.removeChild(errorEl);
						}
					}
				);
			});

			if (unmatched.length) {
				showFormError(unmatched.join(' '));
			}

			if (firstInvalid) {
				firstInvalid.focus();
			}
		}

		function showSuccess(data) {
			var message = document.createElement('div');
			message.className = 'nk-exit-intent-poll-message';
			message.setAttribute('role', 'status');

			var title = document.createElement('p');
			title.className = 'nk-exit-intent-poll-message-title';
			title.textContent = data.messageTitle || dialog.dataset.successTitle;
			message.appendChild(title);

			submitted = true;
			body.hidden = true;
			form.appendChild(message);

			setTimeout(close, SUCCESS_CLOSE_MS);
		}

		form.addEventListener('submit', function (event) {
			event.preventDefault();

			// One answer per popup - the fields are hidden after success anyway.
			if (sending || submitted) {
				return;
			}

			sending = true;
			form.classList.add('nk-exit-intent-poll-form--sending');
			clearErrors();

			var formData = new FormData(form);
			var payload = new FormData();

			formData.forEach(function (value, key) {
				if (value !== null && value !== '') {
					payload.append(key, value);
				}
			});

			window.dataLayer.push({ event: dataLayerName + '_send' });

			fetch(form.action, {
				method: 'POST',
				body: payload,
				credentials: 'same-origin',
			})
				.then(function (response) {
					return response
						.json()
						.catch(function () {
							return {};
						})
						.then(function (json) {
							return { ok: response.ok, json: json };
						});
				})
				.then(function (result) {
					var json = result.json || {};

					if (!result.ok) {
						if (json.data && json.data.dataLayer && json.data.dataLayer.event) {
							window.dataLayer.push(json.data.dataLayer);
						}

						if (json.code === 'rest_invalid_param' && json.data && json.data.params) {
							showFieldErrors(json.data.params);
						} else {
							showFormError(json.message);
						}
						return;
					}

					if (json.dataLayer && json.dataLayer.event) {
						window.dataLayer.push(json.dataLayer);
					}

					showSuccess(json);
				})
				.catch(function () {
					showFormError();
				})
				.then(function () {
					sending = false;
					form.classList.remove('nk-exit-intent-poll-form--sending');
				});
		});

		/*
		|--------------------------------------------------------------------------
		| Triggers
		|--------------------------------------------------------------------------
		*/

		// 1. Desktop: cursor leaves the top of the viewport.
		function onMouseOut(event) {
			if (event.clientY <= 0 && event.relatedTarget === null) {
				tryShow('mouseleave');
			}
		}

		// 2. Mobile: a fast upward scroll (mimics pulling down to reveal the
		// browser chrome before navigating away).
		var lastScrollY = window.scrollY;
		var scrollUpAccum = 0;
		var scrollWindowStart = Date.now();

		function onScroll() {
			resetInactivity();

			// The accumulator below is the mobile-only trigger; on desktop this
			// listener exists purely so that scrolling counts as a sign of life.
			if (pointerFine) {
				return;
			}

			var currentY = window.scrollY;
			var delta = lastScrollY - currentY;
			lastScrollY = currentY;

			if (delta <= 0) {
				scrollUpAccum = 0;
				scrollWindowStart = Date.now();
				return;
			}

			var now = Date.now();
			if (now - scrollWindowStart > SCROLL_WINDOW_MS) {
				scrollUpAccum = 0;
				scrollWindowStart = now;
			}

			scrollUpAccum += delta;

			if (scrollUpAccum >= SCROLL_THRESHOLD) {
				tryShow('scroll-up');
			}
		}

		// 3. Inactivity timer, reset by any sign of life.
		var inactivityTimer = null;

		function resetInactivity() {
			if (inactivityTimer) {
				clearTimeout(inactivityTimer);
			}
			inactivityTimer = setTimeout(function () {
				tryShow('inactivity');
			}, INACTIVITY_MS);
		}

		// 4. Tab was hidden for a while, then came back - treat it as "checked
		// something else and is now deciding whether to stay".
		var hiddenAt = null;

		function onVisibilityChange() {
			if (document.hidden) {
				hiddenAt = Date.now();
				return;
			}

			if (hiddenAt && Date.now() - hiddenAt >= HIDDEN_MS) {
				tryShow('visibility');
			}

			hiddenAt = null;
		}

		// 5. Mobile back-button catch: one dummy history entry is pushed up
		// front, so the first back press lands back on the current page (no
		// visible navigation) and shows the popup instead. It's intentionally
		// NOT re-armed after that - a second back press then falls through to a
		// real navigation, since it targets a document entry we never touched.
		//
		// The listener stays until that first back press, even when another
		// trigger showed the popup: the dummy entry is still there then, and
		// without it the visitor's back press would land on this same page and
		// seem to do nothing.
		var backButtonArmed = false;

		function onPopState(event) {
			// Back onto the dummy entry itself, e.g. from an in-page #anchor.
			if (event.state && event.state.nkExitIntentPoll) {
				return;
			}

			cleanupBackButtonCatch();

			if (shown) {
				// The popup has had its turn, so this press was meant to leave.
				history.back();
				return;
			}

			tryShow('back-button');
		}

		function armBackButtonCatch() {
			if (backButtonArmed || !MOBILE_CATCH_BACK) {
				return;
			}
			history.pushState({ nkExitIntentPoll: true }, '', window.location.href);
			backButtonArmed = true;
			window.addEventListener('popstate', onPopState);
		}

		function cleanupBackButtonCatch() {
			if (!backButtonArmed) {
				return;
			}
			backButtonArmed = false;
			window.removeEventListener('popstate', onPopState);
		}

		var activityEvents = ['touchstart', 'keydown', 'pointerdown'];

		function attachTriggers() {
			if (pointerFine) {
				document.documentElement.addEventListener('mouseout', onMouseOut);
			} else {
				armBackButtonCatch();
			}

			// Attached on both paths. Scrolling is a sign of life everywhere, and
			// leaving it off desktop would turn the inactivity timer into a plain
			// "fires N seconds after dwell" popup for anyone reading a long page
			// without clicking - the opposite of an exit intent signal.
			window.addEventListener('scroll', onScroll, { passive: true });

			activityEvents.forEach(function (evt) {
				window.addEventListener(evt, resetInactivity, { passive: true });
			});

			document.addEventListener('visibilitychange', onVisibilityChange);
			window.addEventListener('pagehide', cleanupBackButtonCatch);

			resetInactivity();
		}

		function detachTriggers() {
			document.documentElement.removeEventListener('mouseout', onMouseOut);
			window.removeEventListener('scroll', onScroll);

			activityEvents.forEach(function (evt) {
				window.removeEventListener(evt, resetInactivity);
			});

			document.removeEventListener('visibilitychange', onVisibilityChange);
			window.removeEventListener('pagehide', cleanupBackButtonCatch);

			if (inactivityTimer) {
				clearTimeout(inactivityTimer);
			}
		}

		// Nothing is eligible to trigger - not even a stray mouseleave - until
		// dwell time has passed, so a visitor who bounces immediately isn't nagged.
		setTimeout(attachTriggers, DWELL_MS);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
